export default "__VITE_ASSET__QL7Ue94M__"